import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CountriesService as CountriesServiceMarklist } from 'app/service/countries.service';
import { AuthService, AvlaRestClientService } from 'base-angular-avla';
import { filter } from 'rxjs/operators';
import { CountriesService, PersonService } from 'services-sc-component';
import {
  AvlaGenericComponent,
  I18nService,
  MessageService,
} from 'shared-angular-components-avla';

declare var $: any;
declare var window: any;

@Component({
  selector: 'country-selection',
  templateUrl: './country-selection.component.html',
  styleUrls: ['./country-selection.component.css'],
  providers: [I18nService, CountriesService, PersonService],
})
export class CountrySelectionComponent
  extends AvlaGenericComponent
  implements OnInit
{
  constructor(
    protected restClientService: AvlaRestClientService,
    public countriesService: CountriesService,
    public countriesServiceMarklist: CountriesServiceMarklist,
    protected personService: PersonService,
    protected activatedRoute: ActivatedRoute,
    protected messageService: MessageService,
    protected authService: AuthService,
    protected i18n: I18nService,
    protected router: Router
  ) {
    super(restClientService, messageService, router, authService, i18n);
    this.window = window;
  }

  ngOnInit() {
    this.getCountries();
    this.selectCountryCodeByUrl();
  }

  public window;
  public countries: any[] = [];
  public disabledChangeCountry = false;

  public urlNow(url: string) {
    if (url.includes('auth/login')) {
      return true;
    }
    return false;
  }

  public getCountries() {
    this.countriesServiceMarklist.findCountries().subscribe(
      data => {
        if (this.errorInResponse(data)) {
          return;
        }
        console.log('paises cargados');
      },
      error => {
        this.routeAccordingError(error);
      }
    );
    this.personService.getAllPersonIdentityTypes().subscribe(
      data => {
        if (this.errorInResponse(data)) {
          return;
        }
        console.log('getAllPersonIdentityTypes');
      },
      error => {
        this.routeAccordingError(error);
      }
    );
    this.countriesServiceMarklist.findCountriesWithDefaultLanguages().subscribe(
      data => {
        if (this.errorInResponse(data)) {
          return;
        }
        let temp = [];
        if (!this.authService.userInfoDto) {
          setTimeout(() => {
            console.log(
              're-consultando getCountries, esperando a authService.userInfoDto'
            );
            this.getCountries();
          }, 300);
        } else {
          for (let c of data) {
            console.log('TEST Iso ' + c.isoCode);
            let test: boolean =
              this.countriesServiceMarklist.validateCountryCodeByGroup(
                c.isoCode,
                this.authService.userInfoDto
              );
            console.log('TEST boolean ' + test);

            if (test) {
              temp.push(c);
              //si el pais no está guardado en la variable service en localStorage
              if (!localStorage.getItem('countryCodeGlobal')) {
                localStorage.setItem('countryCodeGlobal', c.isoCode);
              } else {
                if (!this.countriesService.countryCodeGlobal) {
                  Promise.resolve().then(() => {
                    this.countriesService.countryCodeGlobal =
                      localStorage.getItem('countryCodeGlobal');
                  });
                  Promise.resolve().then(() => {
                    this.router.navigate([this.getCurrentUrl()], {
                      queryParamsHandling: 'merge',
                      queryParams: {
                        cdCountry: localStorage.getItem('countryCodeGlobal'),
                      },
                    });
                  });
                }
              }
            }
          }
        }
        this.countries = temp;
      },
      error => {
        setTimeout(() => {
          console.log(
            're-consultando getCountries, esperando a authService.userInfoDto'
          );
          this.getCountries();
        }, 2000);
        this.routeAccordingError(error);
      }
    );
  }

  public selectCountry(cdCountry: string) {
    if (
      this.countriesService.validateCountryCodeByGroup(
        cdCountry,
        this.authService.userInfoDto
      )
    ) {
      Promise.resolve().then(() => {
        this.router.navigate([this.getCurrentUrl()], {
          queryParamsHandling: 'merge',
          queryParams: { cdCountry: cdCountry },
        });
      });
    }
  }

  setLanguage(event) {
    const country =
      event === 'cl' ? 'es' : event === 'br' ? 'pt' : 'es-' + event;
    let languaje: any = {
      key: country,
      alt: '',
      title: '',
    };
    this.i18n.setLanguage(languaje);
    //this.router.navigate(['home']); //Solo usar suscripción a evento languageChanged para refrescar componentes
  }

  getCurrentUrl() {
    const route = this.router.url.split('?');
    if (route.length > 0) {
      return route[0];
    } else {
      return this.router.url;
    }
  }

  public selectCountryCodeByUrl() {
    this.activatedRoute.queryParams
      .pipe(filter(query => query.cdCountry))
      .subscribe(query => {
        if (!this.authService.userInfoDto) {
          setTimeout(() => {
            console.log(
              're-consultando getCountries, esperando a authService.userInfoDto'
            );
            this.selectCountryCodeByUrl();
          }, 300);
          return;
        } else if (
          query['cdCountry'] &&
          this.countriesService.validateCountryCodeByGroup(
            query['cdCountry'],
            this.authService.userInfoDto
          ) &&
          query['cdCountry'] != this.countriesService.countryCodeGlobal
        ) {
          Promise.resolve().then(() => {
            this.countriesService.countryCodeGlobal = query['cdCountry'];
            localStorage.setItem('countryCodeGlobal', query['cdCountry']);
          });
        }
      });
    let countryCodeTemp = localStorage.getItem('countryCodeGlobal');
    if (countryCodeTemp) {
      this.setLanguage(countryCodeTemp.toLocaleLowerCase());
    }
  }
}
